import { Api } from "@/core/api.js";
const api = new Api();

const state = {
  list: [],
  rooming: {}
};

const getters = {
  getListKeyId: (state, getters, rootState) => () => {
    return state.list;
  },

  getRooming(state) {
    return state.rooming;
  }
};

const actions = {
  loadList({ commit }, params) {
    var path =
      "hotel" +
      (typeof params !== "undefined" && typeof params.event !== "undefined"
        ? "/event/" + params.event
        : "");
    return api.get(path).then(function(response) {
      if (response.status) {
        var data = response.data.data;
        for (var i in data) {
          data[i].visible = true;
        }

        return commit("setList", data);
      }
    });
  },

  loadRooming: ({ commit }, params) => {
    return api
      .get("team/" + params.team_id + "/event/" + params.event_id + "/rooming")
      .then(function(response) {
        if (response.status) {
          var data = response.data;
          for (var i in data) {
            data[i].rooms = parseInt(
              parseInt(data[i].num_rooms_1pax) +
                parseInt(data[i].num_rooms_2pax) +
                parseInt(data[i].num_rooms_3pax) +
                parseInt(data[i].num_rooms_4pax) +
                parseInt(data[i].num_rooms_5pax)
            );
            data[i].pax =
              parseInt(data[i].num_rooms_1pax) * 1 +
              parseInt(data[i].num_rooms_2pax) * 2 +
              parseInt(data[i].num_rooms_3pax) * 3 +
              parseInt(data[i].num_rooms_4pax) * 4 +
              parseInt(data[i].num_rooms_5pax) * 5;
          }

          return commit("setRooming", response.data);
        }
      });
  }
};

const mutations = {
  setList(state, data) {
    state.list = data;
  },

  setRooming(state, rooming) {
    state.rooming = rooming;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
